import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.SKW000.error_id: {
            return `Flow Data could not be checked since the flow profiles are not labeled!`
        }
        case MessageCodes.Internal.TSKW001.error_id: {
            return (
                <>
                    <ResultText>
                        The cross-section cutlines are skewed from normal to stream centerline more than {settings.thresholds.skew_angle} degrees at the following {row.data.length} cross sections. The measured skew angles and (if any) defined skew angles are listed in the following table.
                        Minus sign indicates counterclockwise skew.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 120}}>Measured Skew</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 120}}>Defined Skew</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: 125}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.skew}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.defined_skew}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.TSKW002.error_id: {
            return (
                <>
                    <ResultText>
                        The bridges are skewed from normal to stream centerline more than {settings.thresholds.skew_angle} degrees at the following {row.data.length} bridges. The measured skew angles and (if any) defined skew angles are listed in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 120}}>Measured Skew</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 120}}>Defined Skew</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            (row.data).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: 125}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.skew}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.defined_skew}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.SKW003.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    Cross section cutline doesn't intersect with the stream centerline at RS <CheckCSName csName={x.cross_section} />.
                                    <EmptyLine />
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.SKW004.error_id: {
            return (
                <>
                    <ResultText>Skew Angle could not be calculated for the following {row?.data?.length} cross sections since they are not georeferenced:</ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.SKW005.error_id: {
            return (
                <>
                    <ResultText>Skew Angle could not be calculated for the following {row?.data?.length} bridges since their bounding cross sections are not georeferenced.</ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B12 = {
    RenderDescription,
}